<label class="form-option-label" [class.disabled]="disabled" [ngClass]="size" [for]="labelFor">
  <span><ng-content></ng-content></span>
</label>
